import { useState, useEffect } from 'react';
import { ExclusionService } from '../service/exclusionService';
import { ExclusionOrderModel } from '../models/exclusionOrderModel';

const exclusionService: ExclusionService = new ExclusionService();

export const useExclusionOrders = (profileId: string | undefined) => {
  const [exclusionOrders, setExclusionOrders] = useState<ExclusionOrderModel[]>(
    [],
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!profileId) {
      return;
    }

    const fetchExclusionOrders = async (): Promise<void> => {
      setLoading(true);
      setError(null);

      try {
        const models: ExclusionOrderModel[] =
          await exclusionService.getExclusionsByProfileId(profileId);
        setExclusionOrders(models);
      } catch (err: unknown) {
        console.error('[useExclusionOrders] ERROR', err);
        setError('Failed to fetch exclusion orders');
      } finally {
        setLoading(false);
      }
    };

    fetchExclusionOrders();
  }, [profileId]);

  return { exclusionOrders, loading, error };
};
